import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import Adjustment from '../Adjustment';
import useAxios from 'hooks/useAxios';
import { setLocale } from '@withshepherd/faker';
import Loader from 'components/Loader';

const types = ['Accumulation', 'Adjustment', 'Purchase', 'Pending', 'Balance'];
let countad = [];
const CalculationHeader = ({ activeType,rechargecodelist, tenantID, AccountTypeID, onUpdateType, rowData, data }) => {
  const API = useAxios();
  const [accmulationprice, setAccmulationprice] = useState(0);
  const [adjustprice, setAdjustprice] = useState(0);
  const [pendingprice, setPendingPrice] = useState(0);
  const [purchaseprice, setPurchasePrice] = useState(0);
  // const [loading,setLoading]= useState(false);

  useEffect(() => {
    fetchbalance();
  }, [AccountTypeID])

  useEffect(() => {
    fetchbalance();
  }, [data])
  
  const fetchbalance = async () => {
    // setLoading(true);
    try {
      const { data } = await API.get(
        `SBTenant/${tenantID}/Inventory/Balance/${rowData.ndc}/${rowData.accumulatorID}/${parseInt(AccountTypeID)}`,
        {
          hasDefaultURL: true,
          hideLoder: true,
        });
      if (data) {
        setAccmulationprice(data.totalAccumulations);
        setAdjustprice(data.totalAdjestment);
        setPendingPrice(data.totalPending);
        setPurchasePrice(data.totalPurchase);
        rechargecodelist(data.chargecodeList);
        setLoading(false);
       // setChargeCode(data.chargecodeList)
      }

    } catch (error) {
      // setLoading(false);
    }
  }
  // useEffect(() => {
  //   countad = [];
  //   debugger;
  //   if (activeType == 'Pending') {
  //     for (var x in data) {

  //       countad.push(data[x].packageOrdered)
  //     }
  //     const sum = countad.reduce((acc, curr) => acc + curr, 0);
  //     setPendingPrice(sum)
  //   }
  //   if (activeType == 'Accumulation') {
  //     for (var x in data) {

  //       countad.push(data[x].packages)
  //     }
  //     const sum = countad.reduce((acc, curr) => acc + curr, 0);
  //     setAccmulationprice(sum)
  //   }
  //   if (activeType == 'Purchase') {
  //     for (var x in data) {

  //       countad.push(data[x].invoicedQty)
  //     }
  //     const sum = countad.reduce((acc, curr) => acc + curr, 0);
  //     setPurchasePrice(sum)
  //   }
  //   if (activeType == 'Adjustment') {
  //     for (var x in data) {

  //       countad.push(data[x].packages)
  //     }
  //     const sum = countad.reduce((acc, curr) => acc + curr, 0);
  //     setAdjustprice(sum)
  //   }
  // }, [data])

  return (
    <Row className="my-2 acc-Details">
      <Col
        onClick={() => onUpdateType("Accumulation")}
        className={`px-3 py-2 rounded-1 ${
          activeType === "Accumulation"
            ? "bg-primary text-white border-primary"
            : "text-dark border"
        }`}
      >
        <Row className="my-1 align-items-center">
          {" "}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">Accumulations</h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">
                {Number.isInteger(accmulationprice)
                  ? accmulationprice
                  : accmulationprice.toFixed(5)}
              </span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">+</span>
      </Col>
      <Col
        onClick={() => onUpdateType("Adjustment")}
        className={`px-3 py-2 rounded-1 ${
          activeType === "Adjustment"
            ? "bg-primary text-white border-primary"
            : "text-dark border"
        }`}
      >
        <Row className="my-1 align-items-center">
          {" "}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">Adjustments</h5>
          </Col>
          {/* {loading && <Loader />} */}
          <Row>
            <Col xs="auto">
              {/* <span className="font-weight-500">{adjustprice.toFixed(5)}</span> */}
              <span className="font-weight-500">
                {Number.isInteger(adjustprice)
                  ? adjustprice
                  : adjustprice.toFixed(5)}
              </span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">-</span>
      </Col>
      <Col
        onClick={() => onUpdateType("Pending")}
        className={`px-3 py-2 rounded-1 ${
          activeType === "Pending"
            ? "bg-primary text-white border-primary"
            : "text-dark border"
        }`}
      >
        <Row className="my-1 align-items-center">
          {" "}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">Pending</h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">
                {Number.isInteger(pendingprice)
                  ? pendingprice
                  : pendingprice.toFixed(5)}
              </span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">-</span>
      </Col>
      <Col
        onClick={() => onUpdateType("Purchase")}
        className={`px-3 py-2 rounded-1 ${
          activeType === "Purchase"
            ? "bg-primary text-white border-primary"
            : "text-dark border"
        }`}
      >
        <Row className="my-1 align-items-center">
          {" "}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">Purchases</h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">
                {Number.isInteger(purchaseprice)
                  ? purchaseprice
                  : purchaseprice.toFixed(5)}
              </span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">=</span>
      </Col>
      <Col
        className={`px-3 py-2 rounded-1 ${
          activeType === "Balance"
            ? "bg-primary text-white border-primary"
            : "text-dark border"
        }`}
      >
        <Row className="my-1 align-items-center">
          {" "}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">Balance</h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">
                {(
                  accmulationprice +
                  adjustprice -
                  purchaseprice -
                  pendingprice
                ).toFixed(5)}
              </span>
            </Col>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default CalculationHeader;
